<h2 mat-dialog-title class="text-lg">{{ 'WORKSPACES.DIALOG.TITLE' | transloco }}</h2>
<mat-dialog-content>
  <mat-form-field class="w-full">
    <input [formControl]="nameControl" [placeholder]="'WORKSPACES.DIALOG.PLACEHOLDER' | transloco" matInput />
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close mat-raised-button>{{ 'GENERAL.CANCEL' | transloco }}</button>
  <button
    mat-button
    [type]="'button'"
    [color]="'primary'"
    [disabled]="nameControl.invalid"
    (click)="submit(nameControl.value)"
    mat-raised-button
  >
    {{ 'GENERAL.SAVE' | transloco }}
  </button>
</mat-dialog-actions>
